import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { inject, observer } from 'mobx-react'
import { withRouter } from 'react-router'

import Pane from '../components/Pane'
import PaneWrapper from '../components/PaneWrapper'
import Loader from '../../shared/components/Loader'

@inject('release', 'auth') @observer
class PaneContainer extends Component {

  static propTypes = {
    auth: PropTypes.object,
    release: PropTypes.object,
  }

  componentWillMount() {
    const { release } = this.props
    // reload if the length is currently below 2 which indicates that only
    // a single model was loaded sofar
    if (release.collection.length < 2) {
      this.load()
    }
  }

  load() {
    const { release } = this.props
    if (!release.loading) {
      release.load()
    }
  }

  @autobind
  handleLoad() {
    this.load()
  }

  render() {
    const { release } = this.props

    if (release.loading) {
      return (
        <PaneWrapper>
          <Loader>Laden...</Loader>
        </PaneWrapper>
      )
    }

    if (!release.collection.length) {
      return (
        <PaneWrapper>
          Keine Daten
        </PaneWrapper>
      )
    }

    return (
      <Pane
        onLoad={this.handleLoad}
        data={release}
      />
    )
  }

}

const PaneContainerWithRouter = withRouter(PaneContainer)

export { PaneContainerWithRouter as default }



// WEBPACK FOOTER //
// ./src/release/containers/Pane.js